import { render } from "./MainPlayer.vue?vue&type=template&id=68fcd1bb"
import script from "./MainPlayer.vue?vue&type=script&lang=js"
export * from "./MainPlayer.vue?vue&type=script&lang=js"

import "./MainPlayer.vue?vue&type=style&index=0&id=68fcd1bb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__